<template>
  <div class="d-flex">
    <div class="SUMMARY jc-center p-b-1">
      <div class="pos-relative">
        <pro-avatar
            :image="logo"
            :size="150"
            :topPro="profile.topPro"
            :fiveStar="isFiveStar"
            class="LOGO"/>
      </div>

      <div class="d-flex flex-1-1 fd-column ai-center:mo">
        <div class="d-flex w-100 jc-between fd-column:mo text-center">
          <h2
              class="h2 text-capitalize m-t-0 m-b-1 c-gray90"
              selenium="public-profile-business-name">
            {{ profile.service_provider.business_name }}
          </h2>
          <div class=" d-flex fd-column jc-center ">
            <div
                class="c-gray90 d-flex text-bold jc-end:t jc-center:mo p-r-1"
                selenium="public-profile-share-profile-button">
              Share this Profile
            </div>

            <div class="d-flex jc-center">
              <div
                  v-for="({ icon, socialUrl, name }, index) in socials"
                  :key="`social_${index}`"
                  @click="copy(index, socialUrl)"
                  @mouseover="handleMouseOver(name)">
                <div  class="cur-pointer">
                  <img :src="`${icon}`">
                  <div class="pos-relative d-flex jc-center m-t-1">
                    <div
                        v-if="isCopied && copiedIndex === index || name === hoverName"
                        class="ARROW">
                    </div>
                    <div
                        v-if="showHover && hoverName === name"
                        class="COPIED-TEXT">
                      {{ name }}
                    </div>
                    <div
                        v-else
                        class="COPIED-TEXT"
                        :class="{'d-none' : !isCopied || copiedIndex !== index}">
                      Link Copied
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <h4
            class="h4 m-t-0 m-y-1 cur-pointer"
            @click="$emit('reviews-clicked')"
            selenium="public-profile-stars"
        >
          <rating-stars :value="ratingAverage" darker/>
        </h4>
        <div
            class="c-depot m-b-1 cur-pointer"
            @click="$emit('reviews-clicked')"
            selenium="public-profile-reviews"
        >
          {{ ratingCount }} {{ ratingCount | pluralize('Review') }}
        </div>
        <div v-if="$device.isMobile">
          <img
              src="./assets/ShareAlt.svg"
              width="24"
              height="24"
          >
          <router-link
              :to="{ name: 'pro-public-profile::share' }"
              class="btn-lg link"
              selenium="public-profile-share-profile-button">
            Share this Profile
          </router-link>
        </div>
        <div class="CREDENTIAL-SECTION">
          <div class="CREDENTIAL">
            <div class="CREDENTIAL-ICON bg-green" selenium="public-profile-bgcheck-icon">
              <vk-icon v-if="$device.isMobile" size="13" name="bgcheck"/>
              <vk-icon v-else size="25" name="bgcheck"/>
            </div>
            <div class="CREDENTIAL-CONTENT">
              <div selenium="public-profile-bgcheck-copy">Background Checked</div>
              <router-link
                  :to="{
                    name: 'pro-public-profile::credentials',
                    params: { profile, section: 'background' },
                  }"
                  class="link"
                  selenium="public-profile-bgcheck-link">
                Read more
              </router-link>
            </div>
          </div>
          <div
              v-if="profile.insuranceInfo.isInsured && profile.insuranceInfo.amount > 0"
              class="CREDENTIAL">
            <div class="CREDENTIAL-ICON" selenium="public-profile-insurance-icon">
              <vk-icon v-if="$device.isMobile" class="ICON" size="30" name="insured"/>
              <vk-icon v-else class="ICON" size="60" name="insured"/>
              <div class="BACKER"></div>
            </div>
            <div class="CREDENTIAL-CONTENT">
              <div selenium="public-profile-insurance-copy">Insurance Coverage</div>
              <div
                  class="c-gray50"
                  selenium="public-profile-insurance-amount">
                ${{ profile.insuranceInfo.amount | formatNumber }}
              </div>
              <router-link
                  :to="{
                    name: 'pro-public-profile::credentials',
                    params: { profile, section: 'insurance' },
                  }"
                  class="link"
                  selenium="public-profile-insurance-link">
                Read more
              </router-link>
            </div>
          </div>
          <div v-if="!profile.licenseInfo.isLicensed" class="CREDENTIAL">
            <div class="CREDENTIAL-ICON">
              <vk-icon v-if="$device.isMobile" class="ICON" size="25" name="certfied"/>
              <vk-icon v-else class="ICON" size="50" name="certfied"/>
              <div class="BACKER"></div>
            </div>
            <div class="CREDENTIAL-CONTENT">
              <div>License Information</div>
              <router-link
                  :to="{
                    name: 'pro-public-profile::credentials',
                    params: { profile, section: 'license' },
                  }"
                  class="link">
                Read more
              </router-link>
            </div>
          </div>
          <div v-if="profile.topPro" class="CREDENTIAL">
            <div>
              <img
                  v-if="$device.isMobile"
                  src="@/assets/TopPro.svg"
                  width="26"
                  height="30"
              >
              <img
                  v-else
                  src="@/assets/TopPro.svg"
                  width="52"
                  height="60"
              >
            </div>
            <div class="CREDENTIAL-CONTENT">
              <div>Top Pro</div>
              <router-link
                  :to="{
                    name: 'pro-public-profile::credentials',
                    params: { profile, section: 'top-pro' },
                  }"
                  class="link">
                Read more
              </router-link>
            </div>
          </div>
          <div v-if="isFiveStar" class="CREDENTIAL">
            <div>
              <img
                  v-if="$device.isMobile"
                  src="@/assets/FiveStarPro.svg"
                  width="30"
                  height="30"
                  class="m-t-1"
              >
              <img
                  v-else
                  src="@/assets/FiveStarPro.svg"
                  width="60"
                  height="60"
                  class="m-t-1"
              >
            </div>
            <div class="CREDENTIAL-CONTENT">
              <div>5-Star Pro</div>
              <router-link
                  :to="{
                    name: 'pro-public-profile::credentials',
                    params: { profile, section: 'five-star' },
                  }"
                  class="link">
                Read more
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'profile-summary',
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      url: '',
      isCopied: false,
      disabled: false,
      copiedIndex: null,
      showHover: false,
      hoverName: '',
    };
  },
  computed: {
    ...mapGetters('fullproprofile', ['getRatingAverage', 'getRatingCount']),
    logo () {
      return this.profile.logo;
    },
    isFiveStar () {
      return this.ratingAverage >= 4.5;
    },
    isReviews () {
      return this.$route.meta.reviews;
    },
    ratingCount () {
      return this.isReviews ? this.getRatingCount : this.profile.rating_count;
    },
    ratingAverage () {
      return this.isReviews ? this.getRatingAverage : this.profile.rating_average;
    },
    socials () {
      return [
        {
          icon: require('./assets/facebook_icon.svg'),
          socialUrl: `https://www.facebook.com/sharer/sharer.php?u=${this.url}`,
          name: 'Facebook',
        },
        {
          icon: require('./assets/linkedin_icon.svg'),
          socialUrl: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.url)}`,
          name: 'LinkedIn',
        },
        {
          icon: require('./assets/youtube_icon.svg'),
          socialUrl: 'https://www.youtube.com/',
          name: 'YouTube',
        },
        {
          icon: require('./assets/tiktok_icon.svg'),
          socialUrl: 'https://www.tiktok.com/',
          name: 'TikTok',
        },
        {
          icon: require('./assets/x_icon.svg'),
          socialUrl: `https://twitter.com/share?url=${this.url}`,
          name: 'X',
        },
        {
          icon: require('./assets/nextdoor.svg'),
          socialUrl: 'https://nextdoor.com/',
          name: 'nextdoor',
        },
        {
          icon: require('./assets/Link.svg'),
          socialUrl: '',
          name: 'Copy Link',
        },
      ];
    },
  },
  mounted () {
    this.url = window.location.href.replace('/share', '');
  },
  methods: {
    async copy (index, socialUrl) {
      this.copiedIndex = index;
      try {
        await navigator.clipboard.writeText(this.url);
        this.showHover = false;
        this.isCopied = true;
        this.disabled = true;
        setTimeout(() => {
          this.isCopied = false;
          this.disabled = false;
          this.copiedIndex = null;
          if (socialUrl) {
            window.open(socialUrl, '_blank');
          }
        }, 1500);
      } catch (err) {
        console.error(err);
      }
    },
    handleMouseOver (name) {
      this.hoverName = name;
      this.showHover = true;
      setTimeout(() => {
        this.showHover = false;
        this.hoverName = '';
      }, 1500);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";
  .SUMMARY {
    display: flex;
    @include mobile-only(){
      flex-direction: column;
    };
    @include padding(1 1, 3 0);
    width: 100%;
    color: white;
  }

  .LOGO {
    width:150px;
    height: 150px;
    @include margin-x(auto);
    @include margin-bottom(3);
    @include margin-top(-8);
    @include mobile-only(){
      @include margin-bottom(5);
      @include margin-x(auto);

    }
    background-color: white;
    border: 7px solid white;
    box-sizing: content-box;
    border-radius: 50%;
  }

  .CREDENTIAL-SECTION {
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    flex-wrap: wrap;
    @include desktop() {
      flex-wrap: nowrap;
    }
  }
  .CREDENTIAL {
    @include padding(1);
    @include margin-bottom(1);
    display: flex;
    flex-wrap: nowrap;
    text-align: left;
    width:50%;
    height: 8 * $unit;
    @include mobile-only() {
      padding: 0px 10px 10px 10px;
      @include margin-bottom(6);
      width: 50%;
    }
    @include tablet() {
      padding: 0px 0px 0px 30px;
      width: 50%;
    }
  }

  .CREDENTIAL-ICON {
    @include h4();
    @include square(50px);
    @include mobile-only {
      @include square(25px);
    }
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    flex: 0 0 auto;
    border-radius: 50%;
  }
  .ICON {
    z-index: 10;
  }
  .BACKER{
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: white;
  }

  .CREDENTIAL-CONTENT {
    color: $color-gray90;
    @include padding-top(1);
    @include padding-left(1);
  }
  .COPIED-TEXT {
    position: absolute;
    background-color: #0084FF;
    white-space: nowrap;
    border-radius: 3px;
    padding: 2px 8px;
    font-size: 10px;
  }
  .ARROW {
    width:14px;
    height: 14px;
    position: absolute;
    background-color: #0084FF;
    transform: rotate(45deg);
  }
</style>
